module.exports = {

    server: {
        url: 'https://m-stage.xiuchuan.com',
        staticResourceUrl: 'https://m-stage.xiuchuan.com',
        prefix: '/api',
    },
    recourceUrl: 'https://m-stage.xiuchuan.com',
    uploadUrl: 'https://m-stage.xiuchuan.com/api/uploads',
    dxAppId: '00d556272bc3035c4fba68384b181616',
    wxRedirectUrl:'https%3A%2F%2Fo.xiuchuan.com%2Fspa%2Fwechat-callback',
    regulatoryInfoChannelId:'10110110',
    xcAppId:'wx2125ad42e459a744',
    xcAppName:'秀川产业互联网有限公司',
}

